<template>
  <div>
    <datatable
      title="Presence Report"
      :fields="fields"
      :response="data"
      :filters="filters"
    ></datatable>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import DataTable from '@/components/DataTable'
export default {
  name: 'presence-report',
  data () {
    return {
      time_helper: new TimeHelper(),
      fields: [
        {
          name: 'day of month',
          value: 'day_of_month'
        },
        {
          name: 'week day',
          value: 'week_day'
        },
        {
          name: 'login',
          value: 'login.display_text'
        },
        {
          name: 'logout',
          value: 'logout',
          component: 'PresenceReportLogoutContent'
        },
        {
          name: 'total hours',
          value: 'total_hours',
          component: 'PresenceReportTotalHours'
        }
      ],
      filters: [
        {
          type: 'single',
          designator: 'month',
          options: this.getMonthsOptions()
        },
        {
          type: 'single',
          designator: 'year',
          options: this.getYearsOptions()
        }
      ],
      data: []
    }
  },
  created () {
    this.init()
    this.addRecruiterFilters()
  },
  computed: {
    getSelectedRecruiter () {
      return this.$route.query.recruiter || this.$utils.getOwner().name
    }
  },
  methods: {
    addRecruiterFilters () {
      if (localStorage.getItem('super_admin') == 'true') {
        this.filters.push({
          type: 'single',
          designator: 'recruiter',
          options: this.getRecruitersOptions()
        })
      }
    },
    init () {
      this.populateInitData()
      this.$network_utils.getStats({
        owner: this.getSelectedRecruiter,
        created_by: 'Admin',
        date_from: this.getDateFrom().toUTCString(),
        date_to: this.getDateTo().toUTCString(),
        designator: 'recruiter_login' })
        .then(response => {
          this.data.map(report => {
            for (let i = 0; i < response.length; i++) {
              let login = response[i]
              report.notes = login.content
              let date = new Date(login.created_at)
              if (report.day_of_month == date.getDate()) {
                report.login = { display_text: this.time_helper.getTimeInput(login.created_at), value: login.created_at }
                return report
              }
            }
            report.login = { display_text: 'לא נרשמה כניסה' }
            return report
          })
          this.getLogouts()
        })
    },
    getDateFrom () {
      let date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setMonth(this.$route.query.month)
      date.setFullYear(this.$route.query.year || new Date().getFullYear())
      date.setDate(1)
      return date
    },
    getDateTo () {
      let date = new Date()
      date.setHours(23, 59, 0, 0)
      date.setMonth(this.$route.query.month)
      date.setFullYear(this.$route.query.year || new Date().getFullYear())
      date.setDate(this.getDaysInMonth())
      return date
    },
    getDaysInMonth () {
      return this.time_helper.getDaysInMonth(this.$route.query.month)
    },
    populateInitData () {
      for (let i = 0; i < this.getDaysInMonth(); i++) {
        let day_of_month = i + 1
        let date = new Date()
        date.setMonth(this.$route.query.month)
        date.setDate(day_of_month)
        this.data.push({
          recruiter: this.getSelectedRecruiter,
          day_of_month: day_of_month,
          week_day: this.time_helper.getDayOfWeekInHebrew()[date.getDay()],
          login: { display_text: 'טוען...' },
          logout: undefined,
          total_hours: undefined,
          notes: ''
        })
      }
    },
    getLogouts () {
      let reports_with_login = this.data.filter(report => report.login.value != undefined)
      for (let i = 0; i < reports_with_login.length; i++) {
        let report = reports_with_login[i]
        report.logout = ''
        let login_date = new Date(report.login.value)
        let midnight_date = new Date(login_date)
        midnight_date.setDate(login_date.getDate() + 1)
        midnight_date.setHours(0, 0, 0, 0)
        this.$network_utils.getStats({
          designator: 'recruiter_logout',
          page: 1,
          per: 1,
          sort: '-created_at',
          date_from: login_date.toUTCString(),
          date_to: midnight_date.toUTCString(),
          owner: this.getSelectedRecruiter
        }).then(response => {
          let logout = response[0]
          if (logout == undefined) {
            report.logout = undefined
            return
          }
          report.logout = { display_text: this.time_helper.getTimeInput(logout.created_at), value: logout.created_at }
        })
      }
    },
    getRecruitersOptions () {
      return this.$settings.get({ path: 'owners' }).map(owner => {
        return { text: owner.name, value: owner.name }
      })
    },
    getMonthsOptions () {
      let time_helper = new TimeHelper()
      return time_helper.getMonthsInHebrew().map((month, index) => {
        return { text: month, value: index }
      })
    },
    getYearsOptions () {
      return Array.from({ length: new Date().getFullYear() - 2010 + 1 }, (_, i) => i + 2010).map(year => {
        return { text: year, value: year }
      })
    }
  },
  components: {
    'datatable': DataTable
  }
}
</script>
